import { FORCE_SESSION_STORAGE } from '@portal/config/env';
import { v4 as uuid } from 'uuid';

export const StorageItems = {
  AUTHORIZATION: 'authorization',
  FIREBASE_APP_CHECK: 'X-Firebase-AppCheck',
  DEVICE_ID: 'device-id',
  PUBLIC_KEY: 'publicKey',
  PRIVATE_KEY: 'privateKey',
  SYMMETRIC_KEY: 'symmetricKey',
  SESSION_TOKEN: 'session-token',
  AUTH_USER_ADMIN: 'auth-user-admin',
  PAYMENT_ACCOUNT_ID: 'payment-account-id',
  IV: 'iv',
  REFRESH_TOKEN: 'refresh-token',
  MAIN_ACCOUNT_ACCESS_TOKEN: 'main-account-access-token',
  MAIN_ACCOUNT_REFRESH_TOKEN: 'main-account-refresh-token',
  PIX_PORTABILITY_CONFIRMED: 'pix_portability_confirmed',
  EXTRACT_FILTER_STORAGE_KEY: 'extract_date_filter',
  ONBOARDING_TAX_ID: 'onboarding-tax-id',
};

export const PIX_PORTABILITY_CACHE_TTL = 120000;

export const clear = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const clearCookies = () => {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
};

export const clearAllStorages = () => {
  localStorage.clear();
  sessionStorage.clear();
  clearCookies();
};

//local storage
export const getItem = (key: string): string | null => {
  if (FORCE_SESSION_STORAGE && key !== StorageItems.DEVICE_ID) {
    return getSessionItem(key);
  } else {
    return localStorage.getItem(key);
  }
};

export const setItem = (key: string, value: string) => {
  if (FORCE_SESSION_STORAGE && key !== StorageItems.DEVICE_ID) {
    setSessionItem(key, value);
  } else {
    localStorage.setItem(key, value);
  }
};

export const removeItem = (key: string) => {
  if (FORCE_SESSION_STORAGE && key !== StorageItems.DEVICE_ID) {
    removeSessionItem(key);
  } else {
    localStorage.removeItem(key);
  }
};

//session storage
export const getSessionItem = (key: string): string | null =>
  sessionStorage.getItem(key);

export const setSessionItem = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

export const removeSessionItem = (key: string) => {
  sessionStorage.removeItem(key);
};

//functions
export const getDeviceId = () => {
  const deviceId = getItem('device-id');
  if (deviceId !== null) {
    return deviceId.replaceAll('"', '');
  }
  return deviceId;
};

export const getOrCreateDeviceId = () =>
  (getItem('device-id') || uuid()).replaceAll('"', '');

const StorageService = {
  getItem,
  setItem,
  removeItem,
  getSessionItem,
  setSessionItem,
  removeSessionItem,
  getDeviceId,
  getOrCreateDeviceId,
  StorageItems,
  clearCookies,
  clearAllStorages,
  clearLocalStorage,
  clearSessionStorage,
};

export default StorageService;
